module.exports = __webpack_public_path__ + "img/tooth.c83025b3.svg";